import { gql } from 'apollo-angular';

export const GET_SEASONS = gql`
  query Seasons {
    seasons {
      id
      name
      startDate
      endDate
    }
  }
`;
